export default __webpack_public_path__ + "static/media/stortorget.d0f73046.svg";